
import { FC } from "react";
import { HappyIcon } from "shared/ui/icons/happyIcon";
import { MiddleHapinessIcon } from "shared/ui/icons/middleHapinessIcon";
import { SadIcon } from "shared/ui/icons/sadIcon";
import {
    HiveHapinessContainer,
    HiveHapinessIconWrapper,
    HiveHapinessValue
} from "features/hives/ui/hivesTable/styles.ts";

type Props = {
    value: number | string | null;
};

export const HiveHapinessCell: FC<Props> = ({ value }) => {
    if (value === null || value === undefined || value === "") return null;

    const num = typeof value === "number" ? value : parseFloat(value);
    let Icon = MiddleHapinessIcon;

    if (num >= 4.8) Icon = HappyIcon;
    else if (num <= 3.5) Icon = SadIcon;

    return (
        <HiveHapinessContainer>
            <HiveHapinessIconWrapper>
                <Icon />
            </HiveHapinessIconWrapper>
            <HiveHapinessValue>{num.toFixed(1)}</HiveHapinessValue>
        </HiveHapinessContainer>
    );
};

